/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "818C6ACF-67CE-4D54-859E-0E47C79150AF",
  "sitecoreApiHost": "https://services.jumeirah.com",
  "jssAppName": "cakery",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "https://services.jumeirah.com/sitecore/api/graph/edge"
};